import { render, staticRenderFns } from "./managedetail.vue?vue&type=template&id=4867cc00&scoped=true&"
import script from "./managedetail.vue?vue&type=script&lang=js&"
export * from "./managedetail.vue?vue&type=script&lang=js&"
import style0 from "@/components/Cropper/cropper.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./managedetail.vue?vue&type=style&index=1&id=4867cc00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4867cc00",
  null
  
)

export default component.exports